export enum EnumHrmType {
    NONE = 'NONE',
    BUSINESS_PHONE_NUMBER = 'BUSINESS PHONE NUMBER',
    EMAIL = 'EMAIL',
    HOME_PHONE_NUMBER = 'HOME PHONE NUMBER',
    MOBILE_PHONE = 'MOBILE PHONE',
    BUSINESS_MOBILE_PHONE_NUM = 'BUSINESS MOBILE PHONE NUM',
    OTHER = 'OTHER',
    EMERGENCY_CONTRACT_PHONE = 'EMERGENCY CONTRACT PHONE',
    START_DATE_TO_COMPANY = 'START DATE TO COMPANY',
    SYNDICATE = 'SYNDICATE',
}
